import { render } from "./ImageDataConfigEditor.vue?vue&type=template&id=cb05ece6&ts=true"
import script from "./ImageDataConfigEditor.vue?vue&type=script&lang=ts"
export * from "./ImageDataConfigEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__